import React, { useState, useEffect, useRef } from "react"; // Added React imports
import { Loader2 } from "lucide-react";
import { CallToActionSection } from "./sections/CallToActionSection/index.js";
import { FeaturesOverviewSection } from "./sections/FeaturesOverviewSection/index.js";
import { FooterSection } from "./sections/FooterSection/index.js";
import { HeroSection } from "./sections/HeroSection/index.js";
import { useParams, useNavigate } from "react-router-dom";
import { ClaimModal } from "@/app/Views/Companies/CompanyClaim/sections/CalimModal/index.js";
import { useCompany } from "@/app/services/create-resume/queries.js";
import { toast } from "sonner";

const CompanyClaim = () => {

	const { companyId } = useParams();
  const navigate = useNavigate();
  const [isHidden, setIsHidden] = useState(false);
  const lastScrollY = useRef(0);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { data, isLoading: loadingCompany, isError } = useCompany(companyId);

  useEffect(() => {
    if (isError) {
        toast.error("Company details failed to load.");
        navigate(-1);
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        // Scrolling down past a certain threshold
        setIsHidden(true);
      } else if (currentScrollY < lastScrollY.current) {
        // Scrolling up
        setIsHidden(false);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {loadingCompany && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-75">
          <Loader2 className="h-12 w-12 animate-spin text-primary-700" />
        </div>
      )}
      {!loadingCompany && !isError && data && (
        <main className="bg-white w-full flex flex-col" data-model-id="257:2100">
          <header
            className={`w-full border-b border-gray-200 bg-white transition-all duration-300 ease-in-out ${
              isHidden ? "-translate-y-full" : "translate-y-0"
            } sticky top-0 z-50`} // Modified header classes
          >
            <div className="flex items-center justify-between gap-4 px-4 md:px-8 lg:px-20 py-4 max-w-[1280px] mx-auto">
              <div className="flex items-center gap-4">
                <img
                  className="w-[98px] h-10 object-cover"
                  alt="Logo grayscale"
                  src="/images/claim-landing/logo-grayscale.png"
                />
              </div>
            </div>
          </header>

          <div className="w-full flex flex-col">
            <HeroSection onClaimClick={() => setIsModalOpen(true)} companyName={data.data.company_name} />
            <FeaturesOverviewSection />
            <CallToActionSection companyName={data.data.company_name} companyId={companyId} />
            <FooterSection />
          </div>

			    <ClaimModal open={isModalOpen} onOpenChange={setIsModalOpen} companyId={companyId} companyName={data.data.company_name} />
        </main>
      )}
    </>
  );
};

export default CompanyClaim;